import React, { Component } from 'react'
import engines from "../img/engines.png";
import smoke from "../img/smoke.png";
// import smoke from "../img/smokey1.gif";
// import logo from '../assets/load.gif'
import AOS from 'aos';

class Updates extends Component {
  render() {
    AOS.init();
    return (
      <>
       <section className="rocket container buffer2">
          <div className="left-block">
            
            <div className="block first-stage">
              <h2 className="with-underline">FIRST STAGE</h2>
              <p>
                Falcon 9’s first stage incorporates nine Merlin engines and
                aluminum-lithium alloy tanks containing liquid oxygen and rocket-grade
                kerosene (RP-1) propellant.
              </p>
              <button className="ui inverted grey button">LEARN MORE</button>
            </div>
            
            <div className="block capacity">
              <div>
                <h4 className="with-underline">Thrust At Sea Level</h4>
                <div
                data-aos="fade-left"
                data-aos-duration="2300"
                >
                  <hr />
                </div>
                <h6>7,607kN1</h6>
              </div>
            </div>
          </div>

          <div className="rocket-body smoke">
            <div data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="2300">
              <img src={smoke} alt="smoke" />
            </div>
          </div>

          <div className="right-block">
            <div className="block engines">
              <img src={engines} alt="engines" />
            </div>
            <div className="block marine">
              <h2>NINE MARLINE ENGINES</h2>
              <p>
                With its nine first-stage Merlin engines clustered together, Falcon 9
                can sustain up to two engine shutdowns during flight and still
                successfully complete its mission. Falcon 9 is the only launch vehicle
                in its class with this key reliability feature.
              </p>
              <button className="ui inverted grey button">LEARN MORE</button>
            </div>
            
          </div>
        </section>
      </>
    )
  }
}

export default Updates
